
class DateFormat
{
    static fullDate(date: Date): string {
        return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
    }
}

export default DateFormat;
